import React from 'react';
import { Plus, RotateCw, AlertCircle } from 'lucide-react';
import TankCard from './TankCard';

/**
 * WineryTab Component
 * Displays winery tank monitoring information
 * 
 * @param {Object} props Component properties
 * @param {Array} props.tanks Array of tank data objects
 * @param {Function} props.onAddTank Function to call when adding a new tank
 * @param {Function} props.onEditTank Function to call when editing a tank
 * @param {Function} props.onDeleteTank Function to call when deleting a tank
 * @param {Function} props.onToggleJacket Function to call when toggling jacket state
 * @param {Function} props.onSetTemperature Function to call when setting temperature
 * @param {Function} props.onRefresh Function to call when refreshing data
 * @param {Date|null} props.lastRefresh Timestamp of last data refresh
 */
const WineryTab = ({ 
  tanks, 
  onAddTank, 
  onEditTank, 
  onDeleteTank, 
  onToggleJacket, 
  onSetTemperature, 
  onRefresh, 
  lastRefresh 
}) => {
  // Sort tanks for better organization
  const sortedTanks = [...tanks].sort((a, b) => {
    if (a.displayOrder !== b.displayOrder) {
      return a.displayOrder - b.displayOrder;
    }
    return a.tankName.localeCompare(b.tankName);
  });

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h5>Fermentation Tanks</h5>
        <div className="btn-group">
          <button
            className="btn btn-outline-secondary"
            onClick={onRefresh}
            title="Refresh data"
          >
            <RotateCw size={16} className="me-1" />
            Refresh
            {lastRefresh && 
              <small className="ms-1 text-muted">
                ({new Date(lastRefresh).toLocaleTimeString()})
              </small>
            }
          </button>
          <button
            className="btn btn-outline-primary"
            onClick={onAddTank}
          >
            <Plus size={16} className="me-1" />
            Add Tank
          </button>
        </div>
      </div>

      <div className="row">
        {sortedTanks.length === 0 ? (
          <div className="col-12">
            <div className="alert alert-info">
              <AlertCircle size={18} className="me-2" />
              No tanks configured yet. Click "Add Tank" to add your first tank.
            </div>
          </div>
        ) : (
          sortedTanks.map((tank) => (
            <TankCard
              key={tank.tankID}
              tank={tank}
              onEdit={() => onEditTank(tank)}
              onDelete={onDeleteTank}
              onToggleJacket={onToggleJacket}
              onSetTemperature={onSetTemperature}
            />
          ))
        )}
      </div>
    </div>
  );
};

export default WineryTab;